import axios from "../api/axios"; // Importing Axios for making HTTP requests

export const StripeCheckout = async (userid , Email , planType) => {
  try {
    const response = await axios.post("/stripe/StripeCheckout", {
      userid: userid,
      Email: Email,
      planType:planType
    });

    return response; 
  } catch (error) {
    throw error;
  }
};
